export enum ChequeProviderEnum {
    CUSTOMER = 'customer',
    GUARANTOR = 'guarantor',
    NO_CHEQUE = 'no_cheque',
}